import { z } from 'zod'

export const schema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string().min(1),
    slug: z.string().min(1),
    blog_posts: z.string().nullable().optional(),
    publishedAt: z.string().nullable(),
  }),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  slug: z.string().min(1),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
